import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  Container, 
  Typography, 
  Box, 
  CircularProgress, 
  Snackbar, 
  Alert 
} from '@mui/material';
import FormInstituicao from '../components/Instituicoes/FormInstituicao';
import { useAuth } from '../hooks/useAuth';
import { obterDadosInstituicao, atualizarPerfilInstituicao } from '../services/instituicaoService';

const CompletarPerfilPage = () => {
  const { tipo } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dadosIniciais, setDadosIniciais] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  useEffect(() => {
    const fetchDadosIniciais = async () => {
      if (tipo === 'instituicao' && user && user.instituicaoId) {
        try {
          const dados = await obterDadosInstituicao(user.instituicaoId);
          setDadosIniciais(dados);
        } catch (err) {
          console.error('Erro ao buscar dados da instituição:', err);
          setError('Falha ao carregar os dados iniciais. Por favor, tente novamente.');
        }
      }
      setLoading(false);
    };

    fetchDadosIniciais();
  }, [tipo, user]);

  const handleSubmit = async (formData) => {
    try {
      setLoading(true);
      if (tipo === 'instituicao' && user && user.instituicaoId) {
        await atualizarPerfilInstituicao(user.instituicaoId, formData);
        setSnackbarMessage('Perfil atualizado com sucesso!');
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
        localStorage.setItem('perfilAtualizado', 'true');
        setTimeout(() => navigate('/dashboard'), 2000);
      }
    } catch (err) {
      console.error('Erro ao atualizar perfil:', err);
      setError('Falha ao atualizar o perfil. Por favor, tente novamente.');
      setSnackbarMessage('Erro ao atualizar perfil. Tente novamente.');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  const renderFormulario = () => {
    switch (tipo) {
      case 'instituicao':
        return <FormInstituicao instituicaoInicial={dadosIniciais} onSubmit={handleSubmit} />;
      case 'estudante':
        // Implementar FormEstudante quando estiver pronto
        return <div>Formulário de Estudante (a ser implementado)</div>;
      case 'admin':
        // Implementar FormAdmin quando estiver pronto
        return <div>Formulário de Admin (a ser implementado)</div>;
      default:
        return <Typography color="error">Tipo de usuário não reconhecido</Typography>;
    }
  };

  if (loading) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Complete seu perfil
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {renderFormulario()}
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default CompletarPerfilPage;